/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import Splide from '@splidejs/splide';

// Import our default css theme for splide
import '@splidejs/splide/css';

// This should only be output on the frontend of the site - NOT the editor

document.addEventListener( 'DOMContentLoaded', () => {

  // Splide
  const carousels = document.querySelectorAll('.carousel')

  if(!!carousels){

    carousels.forEach(carousel => {

			// Main Carousel
			let main = new Splide( carousel.querySelector('#main-carousel'), {
				type      : 'fade',
				rewind    : true,
				drag	  : false,
				pagination: false,
				arrows    : true,
				lazyLoad  : 'nearby'
			});

			// Thumbnail carousel
			let thumbnails = new Splide( carousel.querySelector('#thumbnail-carousel'), {
				fixedWidth: 100,
				fixedHeight: 60,
				gap       : 10,
				rewind    : true,
				pagination: false,
				isNavigation: true,
				focus      : 'center',
				breakpoints: {
					620: {
						fixedWidth : 60,
						fixedHeight: 44,
					},
				},
			});

			main.sync( thumbnails );
			main.mount();
			thumbnails.mount();

		});
  }
});
